import { httpRequest } from "../../http";
import { PresignResponse } from "@models/IngestRun.model";

export class CommandPresignUpload {
  async run(
    organizationId: number,
    filename: string,
    contentType?: string,
    ingestDefinitionId?: number,
  ): Promise<PresignResponse> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/files/presign/`;
    return httpRequest<PresignResponse>(url, {
      method: "POST",
      body: {
        organization_id: organizationId,
        filename,
        content_type: contentType,
        // Files the upload under the definition's etl/<ingest_dir>/processing/
        // subtree instead of the org's first active definition's (MPN-1445).
        ingest_definition_id: ingestDefinitionId,
      },
    });
  }
}
